<template>
  <div class="SlideFooter">
    <div v-if="content.promptText" class="promptText">{{ content.promptText }}</div>
    <div class="buttons">
      <button v-if="!isStartingSlide"
        class="backButton"
        @click="$emit('back')"
      >
        <span v-html="arrowLeftSvg"></span>
        {{ localeStrings.back }}
      </button>
      <SlideButton v-if="content.nextButtonText"
        :text="content.nextButtonText"
        @click="$emit('next')"
      />
    </div>
    <ProgressBar v-bind="{ progress }" class="progressBar" />
  </div>
</template>

<script>
import arrowLeftSvg from '../assets/arrow-left.svg?raw'
import strings from '../strings.json'

import ProgressBar from './ProgressBar.vue'
import SlideButton from './SlideButton.vue'

export default {
  components: {
    ProgressBar,
    SlideButton,
  },
  props: {
    content: Object,
    isStartingSlide: Boolean,
    progress: Number,
  },
  inject: ['locale'],
  data() {
    return {
      arrowLeftSvg,
      localeStrings: strings[this.locale],
    }
  },
}
</script>

<style scoped>

.promptText {
  font-weight: 600;
  font-size: var(--font-size-4);
  line-height: 1.25;
  color: var(--text-color-white);
}

.buttons {
  margin-top: var(--spacing-5);
  display: flex;
  flex-direction: column-reverse;
  row-gap: var(--spacing-6);
}

.backButton {
  font-weight: 500;
  font-size: var(--font-size-2);
  color: var(--text-color-white);
  display: inline-flex;
  align-items: center;
  column-gap: 0.5rem;
  transition: filter 0.15s;
}

.backButton:hover {
  filter: brightness(0.85);
}

.progressBar {
  margin-top: var(--spacing-7);
}

@media (--screen-lg) {

  .buttons {
    display: flex;
    flex-direction: row;
    min-height: 3.5rem;
    column-gap: var(--spacing-10);
  }
}
</style>
